"use strict"

import { eventBus} from "@minddraft/adamantium-frontend-app";

export const navTo = (event) => {
	event.preventDefault();
	const closestElement = event.composedPath().find((element) => {
		return element.localName === 'a';
	});
	const path = closestElement.getAttribute("href");	
	eventBus.dispatchEvent("navigate", {path});
};


export const scrollToElement = (element, wrapper = false) => {

	if(wrapper) {
		document.querySelector(wrapper).scrollTo({
			top: document.querySelector(element).offsetTop,
			left: 0,
			behavior: 'smooth'
		})	
	} else {
		window.scrollTo({
			top: document.querySelector(element).offsetTop,
			left: 0,
			behavior: 'smooth'
		})
	}
};